const compareIndices = (a, b, originalArrayIndices) => {
    const aIndex = originalArrayIndices.indexOf(a.name);
    const bIndex = originalArrayIndices.indexOf(b.name);
    return aIndex - bIndex;
};

// A higher-order function to have somewhat flexible sorting functions -- based on underscore's sortBy
const createStableSortFunction = (category, originalArrayIndices) => (a, b) => {
    if (a[category] > b[category]) {
        return 1;
    }
    if (a[category] < b[category]) {
        return -1;
    }
    return compareIndices(a, b, originalArrayIndices);
};

const createIntervalStableSortFunction = (category, originalArrayIndices) => (a, b) => {
    if (a.intervals[0][category] > b.intervals[0][category]) {
        return 1;
    }
    if (a.intervals[0][category] < b.intervals[0][category]) {
        return -1;
    }
    return compareIndices(a, b, originalArrayIndices);
};

/* Stable sorting is like regular sorting, but when two items are equivalent their sort positions are determined by
 * their order in the original array.
 * For more, check:
 * https://softwareengineering.stackexchange.com/questions/247440/what-does-it-mean-for-a-sorting-algorithm-to-be-stable
 *
 * In order to do stable sorting we need to keep track of the indices of the original array. The array passed in is
 * an array of objects representing players. Since the names are unique, we're going to map the original array into
 * an array of names as a way to track positions.
 *
 * NOTE This assumes the .map function respects the array's order
 *
 * Afterwards, we use the position array alongside a category variable to create a custom sorting function to use.
 * - The category variable is so this function can be generic and reusable, flexible.
 */
const stableSort = (array, category, isCategoryFromIntervalsProperty = false) => {
    const originalArrayIndices = array.map((playerObj) => playerObj.name);
    const customSortFunc = isCategoryFromIntervalsProperty
        ? createIntervalStableSortFunction(category, originalArrayIndices)
        : createStableSortFunction(category, originalArrayIndices);
    return array.sort(customSortFunc);
};

export default stableSort;
